import './champion-card.css'
import ChampionTitle from './ChampionTitle'
import ChampionImage from './ChampionImage'
import ChampionItems from './ChampionItems'

function ChampionCard({ champion, imageMap, itemComponents, itemImageMap }) {
  const champImg = imageMap[champion.name]

  const tierBorderColors = {
    1: '#A0A0A0',
    2: '#4CAF50',
    3: '#2196F3',
    4: '#9C27B0',
    5: '#FF9800',
    7: 'linear-gradient(90deg, #ff0000, #ff9800, #ffd700, #4caf50, #2196f3)',
  }

  const borderGradient = tierBorderColors[champion.tier] || '#444'

  return (
    <div
      className="champion-card"
      data-tier={champion.tier}
      style={{ '--border-gradient': borderGradient }}
    >
      <ChampionTitle name={champion.name} />
      <div className="champion-card__image-container">
        <ChampionImage champion={champion} champImg={champImg} />
        <ChampionItems
          items={champion.items}
          itemComponents={itemComponents}
          itemImageMap={itemImageMap}
        />
      </div>
    </div>
  )
}

export default ChampionCard
